import request from './request';
import {IDoLoginDataArg, IDoLoginResponseData} from 'models/login';

export const doLogin = (data: IDoLoginDataArg) =>
  request.request<IDoLoginResponseData>({
    url: '/login/',
    method: 'POST',
    data,
  });
